import Laupasat1 from "./laupasat (1).webp";
import Laupasat2 from "./laupasat (2).webp";
import Laupasat3 from "./laupasat (3).webp";
import Laupasat4 from "./laupasat (4).webp";
import Laupasat5 from "./laupasat (5).webp";
import Laupasat6 from "./laupasat (6).webp";

const laupasat = [
  Laupasat1,
  Laupasat2,
  Laupasat3,
  Laupasat4,
  Laupasat5,
  Laupasat6,
];

export default laupasat;
